import * as React from 'react';
import { Checkbox, UIText1, UIText2 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';
import * as styles from './styles.css';

interface IAgreementsBlockProps {
  checked: boolean;
  toggleCheckbox(): void;
}

export const AgreementsBlock: React.FC<React.PropsWithChildren<IAgreementsBlockProps>> = ({
  checked,
  toggleCheckbox,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <>
      <ConditionalWrapper if={isDesktop} ThenComponent={UIText2} ElseComponent={UIText1}>
        <>
          <span className={styles['phrase']}>Продолжая вы соглашаетесь на </span>
          <a
            className={styles['link']}
            href="https://cdn.cian.site/frontend/lead-realtor-form-assets/documents/Consent_to_the_processing_of_personal_data.pdf"
            target="_blank"
            rel="noreferrer"
          >
            обработку персональных данных
          </a>
        </>
      </ConditionalWrapper>
      <div className={styles['checkbox']}>
        <Checkbox
          checked={checked}
          onChange={toggleCheckbox}
          label={
            (
              <ConditionalWrapper if={isDesktop} ThenComponent={UIText2} ElseComponent={UIText1}>
                <>
                  <span className={styles['phrase']}>Соглашаюсь получать </span>
                  <a
                    className={styles['link']}
                    href="https://cdn.cian.site/frontend/lead-realtor-form-assets/documents/Consent_to_receive_advertising.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    маркетинговую коммуникацию
                  </a>
                </>
              </ConditionalWrapper>
            ) as any
          }
        />
      </div>
    </>
  );
};

AgreementsBlock.displayName = 'AgreementsBlock';
